import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import { useAuth } from "../../../hooks/GlobalProvider";
import { FaLock, FaArrowRight } from "react-icons/fa";
import { MdPayment } from "react-icons/md";

function DirectPayment() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const basePrice = parseFloat(queryParams.get("totalPrice")) || 0;
  const handlingCharges = 350;
  const totalPrice = basePrice + handlingCharges;
  const orderlist = queryParams.get("orderlist");
  const upiId = "batchusandeepgupta-1@oksbi";
  const [transactionId, setTransactionId] = useState("");
  const { user } = useAuth();

  // Timer state
  const [timeLeft, setTimeLeft] = useState(600); // 10 minutes in seconds

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/Store/GoldNuggets"); // Redirect when time is up
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [navigate]);

  const handleTransactionIdChange = (e) => {
    setTransactionId(e.target.value);
  };

  const upiPaymentLink = `upi://pay?pa=${upiId}&pn=The%20Gold%20Jar&am=${totalPrice}&cu=INR&tn=Payment%20for%20Gold%20Nuggets`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      transactionId,
      amount: totalPrice,
      mobileNumber: user.phonenumber,
      email: user.emailaddress,
      message: "Payment for Gold Nuggets",
      shortName: "BAT_StoreOrders",
      orderlist,
      quantity: 1,
    };

    try {
      const response = await fetch("https://batchugold.com/apis/DirectPay/directpay.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to store transaction ID");
      }

      const result = await response.json();
      console.log("Transaction stored successfully:", result);
      navigate("/user/paymenthistory");
    } catch (error) {
      console.error("Error storing transaction ID:", error);
    }
  };

  return (
    <section className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white shadow-lg rounded-lg p-8 max-w-3xl w-full">
        <h2 className="text-center text-2xl font-bold text-gray-800 mb-6">Complete Your Payment</h2>
        <div className="flex flex-col md:flex-row gap-6">
          <div className="text-center w-full md:w-1/2">
            <QRCode value={upiPaymentLink} size={200} className="mx-auto mb-4 border p-2" />
            <h3 className="text-lg font-semibold">{upiId}</h3>
            <p className="text-gray-600">Batchu Gold</p>
            <p className="text-red-500 font-medium">+91 93919 35555</p>
            <h4 className="mt-4 text-lg font-bold">Order Summary</h4>
            <p className="text-sm text-gray-700">{orderlist}</p>
            <p className="text-xs text-gray-500">Includes:</p>
            <ul className="text-sm bg-yellow-200 p-2 rounded mt-1">
              <li>GST</li>
              <li>Handling Charges</li>
            </ul>
            <p className="mt-2 text-lg font-bold">Total: ₹{totalPrice}</p>
            <p className="mt-2 text-red-500 font-bold">Time Left: {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')}</p>
          </div>
          <div className="w-full md:w-1/2">
            <div className="space-y-6">
              <div className="flex items-center space-x-4">
                <FaLock className="text-yellow-500 text-2xl" />
                <p className="text-gray-800">Scan the QR Code & Verify Name</p>
              </div>
              <div className="flex items-center space-x-4">
                <MdPayment className="text-yellow-500 text-2xl" />
                <p className="text-gray-800">Ensure Amount Matches: ₹{totalPrice}</p>
              </div>
              <div className="flex items-center space-x-4">
                <FaArrowRight className="text-yellow-500 text-2xl" />
                <p className="text-gray-800">Enter Transaction ID & Submit</p>
              </div>
              <input
                type="text"
                value={transactionId}
                onChange={handleTransactionIdChange}
                placeholder="Enter Transaction ID"
                className="w-full p-2 border rounded-md"
              />
              <button onClick={handleSubmit} className="w-full bg-yellow-500 text-white py-2 rounded-md font-semibold">
                Submit Transaction ID
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DirectPayment;